<template>
  <ul>
    <li
      v-for="(values, facetName) in filteredSelectedFacets"
      :key="facetName"
      class="selectedfacetname"
    >
      <ul>
        <li
          v-for="value in values"
          :key="value"
          class="selectedfacet"
          @click.prevent="removeSelectedFacet(facetName, value)"
        >
          <a :href="generateSelectedFacetUrl(facetName, value)">
            <span class="visually-hidden">{{ texts.taBortFilter }}</span>
            <span>{{ getText(facetName, value) }}</span>
            <Icon :type="'fa-xmark'"></Icon>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import Sok from "common/js/script/sok";
import Icon from "../../image/icon.vue";

export default {
  name: "SearchFacetsSelected",
  props: {
    selectedFacets: {
      type: Object,
      required: true,
    },
    texts: Object,
  },
  components: {
    Icon,
  },
  computed: {
    filteredSelectedFacets() {
      // Filter selectedFacets to include only those with non-empty values
      return Object.fromEntries(
        Object.entries(this.selectedFacets).filter(
          ([_, values]) => Array.isArray(values) && values.length > 0
        )
      );
    },
  },
  methods: {
    generateSelectedFacetUrl(facetName, value) {
      const urlParams = new URLSearchParams(window.location.search);
      const paramName = Sok.generateUrlParamName(facetName);
      const existingValues = urlParams.getAll(paramName);
      let updatedValues = existingValues[0];
      if (!updatedValues) {
        return `?${urlParams.toString()}`; // Return the current URL if no values exist
      }
      updatedValues = updatedValues
        .replace(value, "")
        .replace(/,+$/, "") // Remove trailing commas
        .replace(/^,+/, "") // Remove leading commas
        .replace(/,+/g, ","); // Remove duplicate commas
      urlParams.set(paramName, updatedValues);
      return `?${urlParams.toString()}`;
    },
    getText(facetName, value) {
      return Sok.getText(facetName, value, this.texts);
    },
    removeSelectedFacet(facetName, value) {
      this.$emit("removeSelectedFacet", facetName, value);
    },
  },
};
</script>
